import { generateSectionalIds, populateFields } from "./"

export const mergeAssetFieldWithFormField = (asset: any, form: any) => {
  asset.id = form.id
  asset.assetBindPrefix = form.assetBindPrefix
  asset.assetInstanceId = form.assetInstanceId

  if(asset.fields && Array.isArray(asset.fields)) {
    const updatedField = generateSectionalIds(
      { json: asset },
      form.id
    )

    populateFields(updatedField.fields, { assetInstanceId: form.assetInstanceId, isChildAsset: true })
    return updatedField
  }

  return asset
}
